import { render, staticRenderFns } from "./SwitchBusinessModal.vue?vue&type=template&id=f40acbb4&"
import script from "./SwitchBusinessModal.vue?vue&type=script&lang=js&"
export * from "./SwitchBusinessModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SwitchBusinessModal.vue"
export default component.exports